import _ from 'lodash';

import privateLayout from '@/layouts/Private.vue';
import eingangsrechnungRoutes from './eingangsrechnung';
import lieferscheinRoutes from './lieferscheine';
import werkzeugverwaltungRoutes from './werkzeugverwaltung';
import messmittelverwaltungRoutes from './messmittelverwaltung';
import infrastrukturverwaltungRoutes from './infrastrukturverwaltung';
import prozesskontrollkarteRoutes from './prozesskontrollkarte';
import wareneingangspreufungRoutes from './wareneingangspruefung';
import ressourcenmanagementRoutes from './ressourcenmanagement';
import abmusterungRoutes from './abmusterung';
import qsdashbaordRoutes from './qsdashbaord';
import exportRoutes from './export';
import user from './user';
import settingsRoutes from './settings';

const routes = [
  {
    name: 'session-expired',
    path: '/session-expired',
    component: () => import('@/views/Login.vue'),
    props: {
      sessionExpired: true,
    },
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/Login.vue'),
  },
  {
    name: 'print-werkzeug-barcode',
    path: '/print/werkzeug/barcode/:id',
    component: () => import('@/views/print/Werkzeugbarcode.vue'),
    props: true,
  },
  {
    name: 'print-messmittel-barcode',
    path: '/print/messmittel/barcode/:id',
    component: () => import('@/views/print/Messmittelbarcode.vue'),
    props: true,
  },
  {
    path: '/',
    component: privateLayout,
    children: _.flatten([
      [
        {
          name: 'startseite',
          path: '',
          component: () => import('@/views/Startseite.vue'),
        },
        {
          name: 'forbidden',
          path: '/forbidden',
          component: () => import('@/views/errors/Forbidden.vue'),
        },
      ],
      eingangsrechnungRoutes,
      lieferscheinRoutes,
      werkzeugverwaltungRoutes,
      messmittelverwaltungRoutes,
      infrastrukturverwaltungRoutes,
      prozesskontrollkarteRoutes,
      abmusterungRoutes,
      qsdashbaordRoutes,
      wareneingangspreufungRoutes,
      ressourcenmanagementRoutes,
      exportRoutes,
      user,
      settingsRoutes,
    ]),
  },
  {
    path: '/p/*',
    component: () => import('@/views/redirect/PrivateRedirect.vue'),
  },
  {
    path: '*',
    component: () => import('@/views/errors/NotFound.vue'),
  },
];

export default routes;
